import styled from 'styled-components';
import { useCameraViewContext } from '../../context';
import { ChecklistIcon } from '../icon';
import React from 'react';

const IconWrapper = styled.div<{ isActive: boolean; lift: number }>`
  position: absolute;
  right: 16px;
  bottom: ${props => `${76 + props.lift}px`};
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: ${props => (props.isActive ? '3px solid #fff' : '3px solid #999999')};
  border-radius: 100%;
  z-index: 9999;
`;

type Props = {
  lift?: number;
};

export const HelperTextVerticalToggler: React.FC<Props> = ({ lift = 0 }) => {
  const { showHelperText, setShowHelperText } = useCameraViewContext();

  const toggleText = () => setShowHelperText(c => !c);

  return (
    <IconWrapper lift={lift} isActive={showHelperText} onClick={toggleText}>
      <ChecklistIcon isActive={showHelperText} />
    </IconWrapper>
  );
};
